module.exports = __webpack_public_path__ + "static/media/34_A.80293ad2.png";